<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <div class="text-center">
            <h4>Reporte de Anulaciones</h4>
            <span class="text-center" style="font-weight: 400; font-size: small;">
              Ingresa los datos y realiza tu busqueda
            </span>
          </div>
          <hr class="horizontal dark" />
          <div class="row pl-2 pr-2">
            <div class="col-md-1">  </div>
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Desde</label>
              <datepicker
                v-model="fechaInicio"
                :="basicConfigDatePicker"
                :name="String(n)"
              ></datepicker>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Hasta</label>
              <datepicker
                v-model="fechaFin"
                :="basicConfigDatePicker"
                :name="String(n)"
              ></datepicker>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Documento de Identidad</label>
              <input type="text" class="form-control" v-model="documentoIdentidad">
            </div>
            <!-- <div class="col-md-2">
              <label class="form-control-label">ID Afiliado</label>
              <input type="text" class="form-control" v-model="idAfiliado">
            </div> -->
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Programa</label>
              <input type="text" class="form-control" v-model="programa">
            </div>
            <div class="col-md-2">
              <button class="btn btn-addiuva-dark w-100"  @click="getAnulados" title="Generar" style="margin-top: 30px;">
                <i class="fas fa-search pr-1"></i> Generar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================= RESPONSE ======================================= -->
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div class="row p-2">
          <Toast />
          <DataTable :value="anulaciones" ref="dtanulaciones" stripedRows paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <center class="text-gray">No hay anulaciones que mostrar. </center></template>
            <Column field="factura" header="Factura" sortable></Column>
            <Column field="cuf" header="CUF" sortable></Column>
            <Column field="documento_identidad" header="Doc. Identidad" sortable></Column>
            <Column field="tipo_cobertura" header="Tipo Cobertura" sortable></Column>
            <Column field="total_factura" header="Precio Total Factura" sortable></Column>
            <Column field="sucursal_emision" header="Sucursal Emisión" sortable></Column>
            <Column field="sucursal_anulacion" header="Sucursal Anulación" sortable></Column>
            <Column field="fecha_hora_anulacion" header="Fecha/Hora de Anulación" sortable></Column>
            <Column field="motivo_anulacion" header="Motivo Anulación" sortable></Column>
            <Column field="codigo_usuario_vendedor" header="Código Vendedor" sortable></Column>
            <Column field="nombres_apellidos_vendedor" header="Nombre Vendedor" sortable></Column>
            <template #paginatorstart>
              <button class="btn btn-light" @click="exportCSV($event)" title="Exportar" v-if="anulaciones.length>0">
                <i class="fas fa-download"></i> Exportar CSV
              </button>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Datepicker from 'vuejs3-datepicker';
import Toast from 'primevue/toast';
import axios from 'axios';
import authHeader from '../services/auth-header';
export default {
  name: "reporte-anulaciones",
  components: {
    DataTable,
    Column,
    Toast,
    Datepicker
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      fechaInicio: null,
      fechaFin:null,
      nombres: null,
      apellidos: null,
      numeroCertificado: null,
      documentoIdentidad: null,
      programa: null,
      programasOptions: [],
      usuario: null,
      usuariosOptions: [],
      estado: null,
      statusOptions: [
        {
          text: 'Vigente',
          value: 'VIGENTE'
        },
        {
          text: 'En Mora',
          value: 'MORA'
        },
        {
          text: 'Anulado',
          value: 'ANULADO'
        }
      ],
      formaPago: null,
      formasPagoOptions: [
        {
          text: 'Efectivo',
          value: 'Efectivo'
        },
        {
          text: 'Tarjeta de Crédito/Débito',
          value: 'Tarjeta de Crédito/Débito'
        }
      ],
      showProfileDropdown: false,
      anulaciones: [],

    };
  },
  methods: {
    getAnulados() {
      this.anulaciones = [];
      //let myArray = this.fechaInicio != null ? this.fechaInicio.toString().split("T") : [];
      //let fechaInicio = myArray[0] != '' ? myArray[0] : '';
      let payload = {
        "fecha_inicio": this.fechaInicio ? (this.changeIsoToDate(this.fechaInicio) ?? '') : '',
        "fecha_fin": this.fechaFin ? (this.changeIsoToDate(this.fechaFin) ?? '') : '',
        "documento_identidad": this.documentoIdentidad ?? '',
        "tipo_cobertura": this.programa ?? '',
      }
      // Send Data by Axios
      let url = this.API_URL + "/reporte_anulaciones";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let anulaciones = [];
            data.forEach(a => {
              anulaciones.push({
                id_venta: a.id_venta ?? '',
                factura: a.factura ?? '',
                cuf: a.cuf ?? '',
                id_asegurado: a.id_asegurado ?? '',
                tipo_cobertura: a.tipo_cobertura ?? '',
                documento_identidad:  a.documento_identidad ?? '',
                total_factura: a.total_factura ?? '',
                sucursal_emision: a.sucursal_emision ?? '',
                sucursal_anulacion: a.sucursal_anulacion ?? '',
                fecha_hora_anulacion: a.fecha_hora_anulacion ?? '',
                motivo_anulacion: a.motivo_anulacion ?? '',
                codigo_usuario_vendedor: a.codigo_usuario_vendedor ?? '',
                nombres_apellidos_vendedor: a.nombres_apellidos_vendedor ?? '',
              });
            });
            anulaciones.forEach(afiliado => {
              afiliado.tarifa = (afiliado.tarifa != '') ? 'Bs. '+ afiliado.tarifa : '';
            });
            this.anulaciones = anulaciones;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    changeIsoToDate: function(isoDate) {
      let date = new Date(isoDate);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return year+'-' + month + '-'+dt;
    },
    validateRoute(){
      let menus = this.getProfileMe?.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Home'});
      }
    },
    exportCSV() {
      this.$refs.dtanulaciones.exportCSV();
    }
  },
  watch: {
    getProfileMe(val) {
      if (val) {
        this.validateRoute();
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.validateRoute();
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
</style>